// Preloader Component
import React from 'react';
import { 
  FileText, 
} from "lucide-react";
import { motion } from "framer-motion";


const Preloader: React.FC = () => {
  const containerVariants = {
    initial: { opacity: 1 },
    animate: { 
      opacity: 1,
      transition: { 
        duration: 0.5,
        when: "beforeChildren",
        staggerChildren: 0.2
      }
    },
    exit: { 
      opacity: 0,
      transition: { 
        duration: 0.5,
        when: "afterChildren"
      }
    }
  };

  const itemVariants = {
    initial: { 
      scale: 0,
      opacity: 0
    },
    animate: { 
      scale: 1,
      opacity: 1,
      transition: { 
        type: "spring",
        stiffness: 200,
        damping: 10
      }
    },
    exit: { 
      scale: 0,
      opacity: 0
    }
  };

  return (
    // The Idead
    <motion.div 
      initial="initial"
      animate="animate"
      exit="exit"
      variants={containerVariants}
      className="fixed inset-0 z-50 flex items-center justify-center bg-purple-50"
    >
      <motion.div 
        variants={itemVariants}
        className="flex flex-col items-center"
      >
        <motion.div 
          variants={itemVariants}
          className="w-24 h-24 bg-purple-600 rounded-full flex items-center justify-center"
        >
          <FileText className="w-12 h-12 text-white" />
        </motion.div>
        <motion.h1 
          variants={itemVariants}
          className="mt-6 text-2xl font-bold text-purple-800"
        >
          TherapistDirect Dashboard
        </motion.h1>
        <motion.div 
          variants={itemVariants}
          className="mt-4 flex space-x-2"
        >
          <div className="w-3 h-3 bg-purple-400 rounded-full animate-bounce"></div>
          <div className="w-3 h-3 bg-purple-400 rounded-full animate-bounce delay-100"></div>
          <div className="w-3 h-3 bg-purple-400 rounded-full animate-bounce delay-200"></div>
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default Preloader;